import SecureLS from 'secure-ls'

const SecureLSCtor: typeof SecureLS =
  (SecureLS as unknown as { default?: typeof SecureLS }).default ?? SecureLS

let instance: SecureLS | null = null
function secure(): SecureLS {
  instance ??= new SecureLSCtor({ isCompression: false })
  return instance
}

/** Exact v3 codec/key compatibility so existing `customizeStore` cache ids survive cutover. */
export const customizeStorage = {
  getItem(key: string): string | null {
    try {
      const value = secure().get(key)
      if (value === '' || value == null) return null
      return typeof value === 'string' ? value : JSON.stringify(value)
    } catch {
      return null
    }
  },
  setItem(key: string, value: string): void {
    try {
      secure().set(key, value)
    } catch (cause) {
      console.warn('[reports] customize cache write failed.', cause)
    }
  },
  removeItem(key: string): void {
    secure().remove(key)
  },
}
